import Splide from "@splidejs/splide";

jQuery(function ($) {
	const base = "gc-hero-with-image";

	if ($(`.${base}__splide`).length) {
		new Splide(`.${base}__splide`, {
			autoplay: true,
			arrows: false,
			classes: {
				pagination: `${base}__pagination`,
				page: `${base}__pagination-item`
			}
		}).mount();
	}

	if ($(`.${base}--large`).length) {
		const banner = $(`.gc-banner`).outerHeight();
		const navbar = $(`.gc-navbar`).outerHeight();
		$(`.${base}--large`).css("min-height", `calc(100vh - ${navbar + banner}px)`);
	}
});
